import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Question, Response, QuestionType, Survey } from '../../types';

interface SurveyResponseState {
    response: Response;
}

const initialState: SurveyResponseState = {
    response: {
        id: '',
        survey: {
            id: '',
            title: '',
            description: '',
            questions: [],
            responses: [],
            creator: '',
            createdAt: new Date(),
            updatedAt: new Date(),
        } as Survey,
        surveyId: '',
        respondant: '',
        responses: [],
        createdAt: new Date(),
        completedAt: null,
        duration: null,
    }
}

export const SurveyResponseSlice = createSlice({
    name: 'survey',
    initialState,
    reducers: {
        setResponse: (state, action: PayloadAction<Response>) => {
            state.response = action.payload;
        },
        updateQuestionResponse: (state, action: PayloadAction<{questionId: string, response: number| string | string[]}>) => {
            state.response.responses = state.response.responses.map(response => response.questionId === action.payload.questionId ? {...response, response: action.payload.response} : response);
        },
        resetResponse: (state) => {
            state.response = {
                id: '',
        survey: {
            id: '',
            title: '',
            description: '',
            questions: [],
            responses: [],
            creator: '',
            createdAt: new Date(),
            updatedAt: new Date(),
        } as Survey,
        surveyId: '',
        respondant: '',
        responses: [],
        createdAt: new Date(),
        completedAt: null,
            duration: null,
            }
        },
    }
});

export default SurveyResponseSlice.reducer;

export const { setResponse, updateQuestionResponse, resetResponse  } = SurveyResponseSlice.actions;